export default {
    SourcingDetails: {
        Basic: 'Account Information',
        Specify: 'Specify shipping',
        order: 'Customer Order No.',
        Internal: 'CSG Order No.',
        Doc: 'Sourcing Order No.',
        creation: 'Sourcing creation time',
        Reason: 'Sourcing failure reason',
        product: 'Sourcing product information',
        All: 'All',
        form: {
            Summarize: 'Group by product',
            line: 'Detailed by product line',
            status: 'Sourcing Status',
            name: 'Product name',
            code: 'Product code',
            SKU: 'SKU name',
            SKUcode: 'SKU',
            quantity: 'Product quantity',
            Whether: 'Whether it is a gift',
            warehouse: 'Delivery logic warehouse code',
            Shipment: 'Delivery logic warehouse name',
            Failure: 'Failure reason',
            Gift: 'Gift',
            Total: 'Total number of product lines:',
            Other: 'Other information',
            returned: 'The returned data is empty. Please contact the administrator.',
        }
    }
};
